import { render, staticRenderFns } from "./EmptyNumbers.vue?vue&type=template&id=7ff587c9&scoped=true"
import script from "./EmptyNumbers.vue?vue&type=script&lang=js"
export * from "./EmptyNumbers.vue?vue&type=script&lang=js"
import style0 from "./EmptyNumbers.vue?vue&type=style&index=0&id=7ff587c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff587c9",
  null
  
)

export default component.exports